/* eslint-disable no-unused-vars */
import {
  dateTimeCol,
  intCol,
  numCol,
  strCol,
} from '@integec/grid-tools/lib/cols'
import React from 'react'
import { toSelectionColProps } from '@integec/grid-tools/lib/utils'

import { monthsMap, yesNoMap, yesNoYNMap } from 'core'

export const SolarTmpImpactSummaryHeaders = [
  // strCol({
  //   ident: 'tabId',
  //   display: 'Tab Id',
  //   sortOrder: 'asc',
  //   isFiltered: true,
  // }),
  intCol({
    ident: 'year',
    display: 'Year',
    // sortOrder: 'asc',
    isFiltered: true,
  }),
  intCol({
    ident: 'month',
    display: 'Month',
    //   sortOrder: 'asc',
    isFiltered: true,
    ...toSelectionColProps(monthsMap),
  }),
  // strCol({
  //   ident: 'impactYN',
  //   display: 'Impact Y / N',
  //   sortOrder: 'asc',
  //   isFiltered: true,
  //   ...toSelectionColProps(yesNoMap),
  // }),
  //   strCol({
  //     ident: 'recordid',
  //     display: 'Recordid',
  //     sortOrder: 'asc',
  //     isFiltered: true,
  //   }),

  strCol({
    ident: 'nercEventImpact',
    display: 'NERC Event Impact',
    // sortOrder: 'asc',
    isFiltered: true,
    width: 150,
  }),
  strCol({
    ident: 'invEventImpact',
    display: 'Inv. Event Impact',
    // sortOrder: 'asc',
    isFiltered: true,
    width: 150,
  }),
  strCol({
    ident: 'nercEventHourImpact',
    display: 'NERC Hours Impact',
    //    sortOrder: 'asc',
    isFiltered: true,
    width: 150,
  }),
  strCol({
    ident: 'invHoursImpact',
    display: 'Inv. Hours Impact',
    //  sortOrder: 'asc',
    isFiltered: true,
    width: 150,
  }),

  strCol({
    ident: 'impactYN',
    display: 'General Impact',
    isFiltered: true,
    //    sortOrder: 'asc',
    dataGetter: ({ rowData, header }) =>
      parseInt(rowData.invEventImpact) > 0 ||
      parseInt(rowData.invHoursImpact) > 0 ||
      parseInt(rowData.nercEventImpact) > 0 ||
      parseInt(rowData.nercEventHourImpact) > 0
        ? 'Yes'
        : 'No',
  }),
  strCol({
    ident: 'impactYn',
    display: 'NERC Impact',
    isFiltered: true,
    //   sortOrder: 'asc',
    dataGetter: ({ rowData, header }) =>
      parseInt(rowData.nercEventImpact) > 0 ||
      parseInt(rowData.nercEventHourImpact) > 0
        ? 'Yes'
        : 'No',
  }),
  // strCol({
  //   ident: 'description',
  //   display: 'Description',
  //   sortOrder: 'asc',
  //   isFiltered: true,
  //   alignment: 'left',
  //   ellipsis: true,
  //   width: 900,
  // }),

  // strCol({
  //   ident: 'action',
  //   display: 'Action',
  //   sortOrder: 'asc',
  //   isFiltered: true,
  // }),
].map(h => ({ ...h, ellipsis: true }))

export const SolarTmpInvEventImpactHeaders = [
  strCol({
    ident: 'eventId',
    display: 'Event Id',
    // sortOrder: 'asc',
    isFiltered: true,
  }),
  strCol({
    ident: 'inverterId',
    display: 'Inverter Id',
    // sortOrder: 'asc',
    width: 170,
    isFiltered: true,
  }),
  dateTimeCol({
    ident: 'eventstart',
    display: 'Event Start',
    // sortOrder: 'asc',
    isFiltered: true,
    width: 200,
    displayFormat: 'MM/DD/YYYY HH:mm',
    dataFormat: 'MM/DD/YYYY HH:mm',
  }),
  dateTimeCol({
    ident: 'eventend',
    display: 'Event End',
    // sortOrder: 'asc',
    isFiltered: true,
    width: 200,
    displayFormat: 'MM/DD/YYYY HH:mm',
    dataFormat: 'MM/DD/YYYY HH:mm',
  }),
  strCol({
    ident: 'eventtype',
    display: 'Event Type',
    // sortOrder: 'asc',
    isFiltered: true,
  }),
  intCol({
    ident: 'causecode',
    display: 'Cause Code',
    // sortOrder: 'asc',
    isFiltered: true,
  }),
  strCol({
    ident: 'operation',
    display: 'Operation',
    // sortOrder: 'asc',
    isFiltered: true,
  }),
  //   strCol({
  //     ident: 'recordid',
  //     display: 'Recordid',
  //     sortOrder: 'asc',
  //     isFiltered: true,
  //   }),
  // strCol({
  //   ident: 'action',
  //   display: 'Action',
  //   sortOrder: 'asc',
  //   isFiltered: true,
  // }),
].map(h => ({ ...h, ellipsis: true }))

export const SolarTmpNercEventImpactHeaders = [
  strCol({
    ident: 'eventId',
    display: 'Event Id',
    // sortOrder: 'asc',
    isFiltered: true,
  }),
  dateTimeCol({
    ident: 'eventstart',
    display: 'Event Start',
    // sortOrder: 'asc',
    isFiltered: true,
    width: 200,
    displayFormat: 'MM/DD/YYYY HH:mm',
    dataFormat: 'MM/DD/YYYY HH:mm',
  }),
  dateTimeCol({
    ident: 'eventend',
    display: 'Event End',
    // sortOrder: 'asc',
    isFiltered: true,
    width: 200,
    displayFormat: 'MM/DD/YYYY HH:mm',
    dataFormat: 'MM/DD/YYYY HH:mm',
  }),
  strCol({
    ident: 'eventtype',
    display: 'Event Type',
    // sortOrder: 'asc',
    isFiltered: true,
  }),
  intCol({
    ident: 'causecode',
    display: 'Cause Code',
    // sortOrder: 'asc',
    isFiltered: true,
  }),
  strCol({
    ident: 'operation',
    display: 'Operation',
    // sortOrder: 'asc',
    isFiltered: true,
  }),
  //   strCol({
  //     ident: 'recordid',
  //     display: 'Recordid',
  //     sortOrder: 'asc',
  //     isFiltered: true,
  //   }),
  // strCol({
  //   ident: 'action',
  //   display: 'Action',
  //   sortOrder: 'asc',
  //   isFiltered: true,
  // }),
].map(h => ({ ...h, ellipsis: true }))

export const SolarTmpInvHoursImpactHeaders = [
  strCol({
    ident: 'inverterId',
    display: 'Inverter Id',
    width: 170,
    // sortOrder: 'asc',
    isFiltered: true,
  }),
  intCol({
    ident: 'year',
    display: 'Year',
    // sortOrder: 'asc',
    isFiltered: true,
  }),
  strCol({
    ident: 'month',
    display: 'Month',
    // sortOrder: 'asc',
    isFiltered: true,
    ...toSelectionColProps(monthsMap),
  }),
  strCol({
    ident: 'dataItem',
    display: 'Data Item',
    // sortOrder: 'asc',
    isFiltered: true,
    width: 300,
  }),
  numCol({
    ident: 'beforeReload',
    display: 'Before Reload',
    // sortOrder: 'asc',
    isFiltered: true,
    alignment: 'right',
  }),
  numCol({
    ident: 'afterReload',
    display: 'After Reload',
    // sortOrder: 'asc',
    isFiltered: true,
    alignment: 'right',
  }),
  strCol({
    ident: 'operation',
    display: 'Operation',
    // sortOrder: 'asc',
    isFiltered: true,
  }),
  //   strCol({
  //     ident: 'recordid',
  //     display: 'Recordid',
  //     sortOrder: 'asc',
  //     isFiltered: true,
  //   }),
  //   strCol({
  //     ident: 'action',
  //     display: 'Action',
  //     sortOrder: 'asc',
  //     isFiltered: true,
  //   }),
].map(h => ({ ...h, ellipsis: true }))

export const SolarTmpNercHoursImpactHeaders = [
  strCol({
    ident: 'inverterGroupId',
    display: 'Inverter Group Id',
    // sortOrder: 'asc',
    isFiltered: true,
    width: 150,
  }),
  intCol({
    ident: 'year',
    display: 'Year',
    // sortOrder: 'asc',
    isFiltered: true,
  }),
  intCol({
    ident: 'month',
    display: 'Month',
    // sortOrder: 'asc',
    isFiltered: true,
    ...toSelectionColProps(monthsMap),
  }),
  strCol({
    ident: 'dataItem',
    display: 'Data Item',
    // sortOrder: 'asc',
    isFiltered: true,
    width: 300,
  }),
  numCol({
    ident: 'beforeReload',
    display: 'Before Reload',
    // sortOrder: 'asc',
    isFiltered: true,
    alignment: 'right',
  }),
  numCol({
    ident: 'afterReload',
    display: 'After Reload',
    // sortOrder: 'asc',
    isFiltered: true,
    alignment: 'right',
  }),
  strCol({
    ident: 'operation',
    display: 'Operation',
    // sortOrder: 'asc',
    isFiltered: true,
  }),
  //   strCol({
  //     ident: 'recordid',
  //     display: 'Recordid',
  //     sortOrder: 'asc',
  //     isFiltered: true,
  //   }),
  //   strCol({
  //     ident: 'action',
  //     display: 'Action',
  //     sortOrder: 'asc',
  //     isFiltered: true,
  //   }),
].map(h => ({ ...h, ellipsis: true }))
